import React, { Component } from 'react';
import Notif from '../../../commonModules/interface/Notif.jsx';
import Select from 'react-select'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createAction, getClientInfoList } from '../../../../../../jsx/actions/devisAction';
import { createClient } from '../../../../../../jsx/actions/clientAction';
import Spin from '../../../commonModules/interface/Spin';
import { fetchAll } from '../../../../../../jsx/actions/stockInitAction';
import Forms from './Forms.jsx';
import PreviewDevis from './PreviewDevis.jsx';
import Photos from '../../../commonModules/interface/input-files';
import { Table, TableRow, TableCell, Button ,TableBody, Box, Card} from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../commonModules/interface/form-input-inline.jsx';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import { deepPurple, teal } from '@material-ui/core/colors';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { SingleSwitch } from '../../../commonModules/MUI/RadioAndCheckbox.jsx';
import { isEmpty } from 'lodash';
import Currency from '../../../commonModules/Currency.jsx';
import { toast } from 'react-toastify';

const translate = {
    "products": "numberProd",
    "accessories": "numberAcc",
    "transport": "numberTrans",
    "mod": "numberMOD",
    "warranty": "numberWarr",
}
class NewDevisForm extends Component{
    state = {
        //Dialog
        dialogClient : false,
        confirmSubmit:false,
        numberProd:1,
        numberAcc:0,
        numberTrans: 0,
        numberMOD: 0,
        numberWarr: 0,
        //New sale
        newDevis:{
            transport:0,
            taxes:0,            
            comments:"",
            discount:0,
            total:0,
            prodTotal:0,
            accTotal:0,
            transTotal:0,
            modTotal:0,
            warrTotal:0,
            products:[
                {
                    display:{value:"", label:""},
                    name:"",
                    product_id:"",
                    TVA:0,
                    quantity:"",
                    dispo:"",                    
                    price:"",
                    priceR:"",
                    priceTotal:"",
                }
            ],
            accessories:[],
            transport:[],
            mod:[],
            warranty: [],
        },
        //errors?
        errors:{
            quantity: "",
            transport:"",
            discount:"",
            taxes:"",
            comments: "",
            products:[
                {
                    product_id:"",
                    quantity:"",
                    priceR:"",
                    priceTotal:"",
                    priceTotal:"",
                    
                }
            ],
            accessories:[],
            transport:[],
            mod:[],
            warranty:[],
        },
        files:[],
        notif:{
            title:"", 
            type:"", 
            message:"",
            display:"hidden"
        },
        inStock: false,
        inStockList: [],
        previousQuot: [],
        selectQuot: {value: "", label: ""}
    }
    
    componentDidMount= async () => {
        console.log("MOUNTING Main Stock ");
        await this.props.getClientInfoList(this.props.clientID)
        console.log('====================================');
        console.log(this.props.ACTIONS[this.props.clientID]);
        console.log('====================================');
        let previousQuot = []
        this.props.ACTIONS[this.props.clientID].forEach(action => {
            if( action.quotation){
                previousQuot.push(action)
            }
        })
        this.setState({ previousQuot })
        if(!this.props.fetched) {
            await this.props.fetchAll()  
        }
    }
    

    // LISTS & TABLES
        
        handleSelectProducts = (option, index, list = "products") => {
            console.log("SELECT HANDLE",{option, index});

            let value = option.value
            const dispo = this.findMax(value)

            let cpProducts = this.state.newDevis[list]
            cpProducts[index].product_id = value
            cpProducts[index].name = option.label
            cpProducts[index].dispo = dispo[0]
            cpProducts[index].price = dispo[1]
            cpProducts[index].priceR = dispo[1]
            cpProducts[index].priceTotal = (dispo[1] * (cpProducts[index].quantity || 0) )
            cpProducts[index].display = option
            
            this.setState({
                ...this.state,
                newDevis:{
                    ...this.state.newDevis,
                    [list]:cpProducts,
                }
            })
        }
            
    // FORMS MANAGER
        findMax = (product_id, list = this.props.STOCKS) => { // return available stock and it's id

            const { PRODUCTS } = this.props
            const { inStockList } = this.state;
            let product = PRODUCTS[product_id]
            let dispo = inStockList[product_id] ? inStockList[product_id] : 0
            let price = 0

            if( product ){
                price = product.prix_venteHT
            } 
            return [dispo, price]
        }
        
        handleAddProd = (list = "products") => {//must add new line in the form to add a product to the sale
            let numberList = translate[list]

            this.setState({
                ...this.state,
                newDevis:{
                    ...this.state.newDevis,
                    [list]:[
                        ...this.state.newDevis[list],{
                        display:{value:"", label:""},
                        product_id:"",
                        name:"",
                        quantity:"",
                        dispo:"",
                        price:"",
                        priceR:"",
                        priceTotal:"",
                        TVA:0,
                    }]
                },
                errors:{
                    ...this.state.errors,
                    [list]:[
                        ...this.state.errors[list],{                      
                        product_id:"",
                        quantity:"",
                        priceR:"",
                        priceTotal:"",
                        
                    }]
                },
                [numberList]:this.state[numberList] + 1,
                
            })   
        }
        handleDeleteProd = (index, list = "products") => {
            let numberList = translate[list]
            
            this.setState({
                ...this.state,
                newDevis:{
                    ...this.state.newDevis,
                    [list]:[
                        ...this.state.newDevis[list].slice(0,index),
                        ...this.state.newDevis[list].slice(index +1),
                    ]
                },
                errors:{
                    ...this.state.errors,
                    [list]:[
                        ...this.state.errors[list].slice(0,index),
                        ...this.state.errors[list].slice(index +1),   
                    ]
                },
                [numberList]:this.state[numberList] - 1,
                
            })   
        }
        handleChange =  (e) => {  
            const field = e.target.name
            const value = e.target.value
            const regex = /^[0-9\b]+$/ // int only

            let splitTab = field.split("-")
            const infos = {
                prod_: { name:"products", total:"prodTotal" },
                acc_ : { name:"accessories", total:"accTotal" },
                trans_ : { name:"transport", total:"transTotal" },
                mod_: { name:"mod", total:"modTotal" },
                warr_: { name:"warranty", total:"warrTotal" },
            }
            if(splitTab.length === 3){
                let list = infos[splitTab[0]]
                
                let name = splitTab[1]
                let index = splitTab[2]
                console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1], splitTab[2], list);
                
                // field = "prod_-quantity-4" || "prod_-product_id-4"
                let cpItems = this.state.newDevis[list.name]
                cpItems[index][name] = value

                if(name === "quantity" || name === "price" || name === "TVA" ) {   
                    if(value ==="" || regex.test(value)){// update value only if its a int
                    let discount = 0;
                    let total = 0;
                    
                    cpItems[index].priceTotal = Math.round(cpItems[index].price * cpItems[index].quantity) 
                    cpItems.map((item, index)=>{
                        if ( item.quantity && item.priceTotal){
                            let puReel = item.priceR ? item.priceR : item.price 
                            let addDiscount = (puReel *(item.quantity)) - item.priceTotal
                            discount += addDiscount > 0 ? addDiscount : 0
                            total += parseFloat(item.priceTotal)
                        }
                    })             
                        this.setState({
                            ...this.state,
                            newDevis:{
                                ...this.state.newDevis,
                                [list.name]:cpItems,
                                discount,
                                [list.total]: total
                            }
                        })
                    }
                    
                } else {
                    this.setState({
                        ...this.state,
                        newDevis:{
                            ...this.state.newDevis,
                            [list]:cpItems,
                        }
                    })
                }
                        
            } else {
                this.setState({
                    ...this.state,
                    newDevis:{
                        ...this.state.newDevis,
                        [field]:value
                    }
                })
            }    
        }

        handleChangePrevDevis = (option) => {
            let newDevis = Object.assign({}, option.value)
            let numberProd = newDevis.products.length
            let numberAcc = newDevis.accessories.length
            let numberTrans = newDevis.transport.length
            let numberMOD = newDevis.mod.length
            let numberWarr = newDevis.warranty.length

            newDevis.products.forEach((prod, i) => {
                const dispo = this.findMax(prod.product_id)
                newDevis.products[i].dispo = dispo[0]
            })
            console.log('====================================');
            console.log({newDevis});
            console.log({option});
            console.log('====================================');
            delete newDevis.id;
            //newDevis.files;
            this.setState({
                selectQuot: option,
                newDevis,
                numberProd,
                numberAcc,
                numberTrans,
                numberMOD,
                numberWarr,
            })
        //     newDevis:{
        //         transport:0,
        //         taxes:0,            
        //         comments:"",
        //         discount:0,
        //         total:0,
        //         prodTotal:0,
        //         accTotal:0,
        //         transTotal:0,
        //         modTotal:0,
        //         warrTotal:0,
        //         products:[
        //             {
        //                 display:{value:"", label:""},
        //                 name:"",
        //                 product_id:"",
        //                 TVA:0,
        //                 quantity:"",
        //                 dispo:"",         //!\ recheck dispo           
        //                 price:"",
        //                 priceR:"",
        //                 priceTotal:"",
        //             }
        //         ],
        //         accessories:[],
        //         transport:[],
        //         mod:[],
        //         warranty: [],
        //     },
        }
        setFiles = (list) => {
            console.log("[INFO] SETPHOTOS", list);
            
            this.setState({
                files:list
                
            })
        }
        validate = () => {
            let noErrors = true
            let errors = Object.assign({}, this.state.errors)
            let lists = ["products", "transport", "mod", "accessories", "warranty"]

            Object.keys(this.state.newDevis).map((field, i) => {                
                if(this.state.newDevis[field] === "" ){// input is empty  
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                        
                } else if(lists.includes(field)){
                    this.state.newDevis[field].map((item, j) => {
                        Object.keys(item).map((field2)=>{ // field2 product_id || quantity
                            
                            if(field2 === "dispo"){
                                errors[field][j][field2] = ""

                            } else if(item[field2] === ""){
                                noErrors = false
                                errors[field][j][field2] = "Veuillez remplir ce champ"
                                
                            } else {
                                errors[field][j][field2] = ""
                            }
                        })
                    })
                
                } else {// not empty
                    errors[field] = ""   
                }
            })
            console.log("[INFO] NOERRORS = ",noErrors);
            console.log("[INFO] VALIDATE, ERRORS = ",errors);
                      
            this.setState({
                ...this.state,
                errors : errors
            })
            return noErrors
        }
        handleNext = () => {
            if(this.validate()){
                this.setState({
                    confirmSubmit: true
                })
            } else {// !VALIDATE
                toast.error( "Le formulaire contient des erreurs")
            }
        }
        
        handleSubmit = async (TOTAL) => {
            let devis = Object.assign({} , this.state.newDevis)
            if (this.props.clientID && this.validate()){

                devis.id=""
                devis.shop_id = ""
                devis.date = new Date()
                devis.client = this.props.clientID
                devis.boxAssoId = this.props.clientID
                devis.totalHT = TOTAL.HT
                // devis.totalTVA = TOTAL.TVA
                devis.totalTTC = TOTAL.TTC
                console.log('====================================');
                console.log("[SUBMIT] Devis form", {devis});
                console.log('===================================='); 

                let action = {}
                action.client_id = this.props.clientID
                action.boxAssoId = this.props.clientID
                action.actionType = "addQuotation"
                action.nextStatus = "WAITING_VALIDATION"
                action.comments = devis.comments              
                action.quotation = devis
                if (this.state.files.length > 0){ 
                    action.uploads = this.state.files
                }
                        
                await this.props.createAction("WAITING_QUOTATION", action)
                    
                if(this.props.state.error){
                    console.log("ERROR", this.props.state.error);
                    this.setState({
                        sending: false,
                    })
                    toast.error( "Un Problème est survenu")
                } else{
                    console.log("fetched");
                    //success 
                    this.setState({
                        sending: false,
                    })
                    toast.info("Devis enregistré avec succès")
                    this.handleClose()
                }                
            } else {// !VALIDATE
                toast.error( "Le formulaire contient des erreurs")
            }
        }
        // notif = (type, message, title = "") => {
        //     this.setState({
        //         notif:{
        //             title, 
        //             type, 
        //             message,
        //             display:"fadeInDown"
        //         },
        //     }) 
        // }
    // CLEAR & DISPLAY
        
        clearForms = async () => {
            this.setState({
                numberProd:1,
                numberAcc:0,
                numberTrans: 0,
                numberMOD: 0,
                numberWarr: 0,
                //New devis
                newDevis:{
                    transport:0,
                    taxes:0,            
                    comments:"",
                    discount:0,
                    total:0,
                    prodTotal:0,
                    accTotal:0,
                    transTotal:0,
                    modTotal:0,
                    warrTotal:0,
                    products:[
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            dispo:"",                    
                            price:"",
                            priceR:"",
                            priceTotal:"",
                            TVA:0,
                        }
                    ],
                    accessories:[],
                    transport:[],
                    mod:[],
                    warranty: [],
                },
                files: [],

                //errors?
                errors:{
                    quantity: "",
                    transport:"",
                    discount:"",
                    taxes:"",
                    comments:"",
                    products:[
                        {
                            product_id:"",
                            quantity:"",
                            priceR:"",
                            priceTotal:"",
                            priceTotal:"",
                            
                        }
                    ],
                    accessories:[],
                    transport:[],
                    mod:[],
                    warranty:[],
                },
                
            })
        }

        handleClose = () => {
            this.setState({
                showSale:false,
                showNew:false,
                showSingleProd: false,
                showSingleShop: false,
                breadcrumb: "",
                confirmSubmit:false,
            });
            this.clearForms()
            this.props.handleClose()
        }
        
        handleChecked = (e) => {
            const { name, checked } = e.target
            console.log({name, checked});
            if (checked) {
                let inStockList = {}
                Object.values(this.props.STOCKS).forEach( stock => {
                    if (!inStockList[stock.product_id]){
                        inStockList[stock.product_id] = 0
                    }
                    inStockList[stock.product_id] += stock.quantity
                })
                this.setState({
                    inStockList,
                    [name]: checked,
                })
            } else {
                this.setState({
                    [name]: checked,
                })     
            }
        }
    render(){
        console.log("[STATE]", this.state);
        console.log("[PROPS]", this.props);
        const { PRODUCTS} = this.props
        const { previousQuot, openQuotList} = this.state;

        return(
            <PopUp
                title="Nouveau Devis"
                maxWidth="xl"
                submitAction={this.state.confirmSubmit ? this.handleSubmit : this.handleNext}
                close={this.state.confirmSubmit ? () => this.setState({confirmSubmit : false}) : this.props.handleClose}
            >
                {this.props.state.fetching && <Spin />}
                {/* if 
                    display={this.state.notif.display} 
                    title={this.state.notif.title} 
                    type={this.state.notif.type} 
                    message={this.state.notif.message} 
                    close={()=> this.setState({
                        notif:{
                            ...this.state.notif,
                            display:"fadeOutUp"
                        }
                    })} /> */}

                {this.state.confirmSubmit ? (

                    <PreviewDevis 
                        devis={this.state.newDevis} 
                        client={this.props.client} 
                    />
                ) : (

                <Box >
                    <Box style={{display: "flex", justifyContent:"space-between"}}>
                        <SingleSwitch label="Produits En Stock" name="inStock" onChange={this.handleChecked} value={this.state.inStock}/>
                        {!isEmpty(previousQuot) &&
                            <Box p={1}>
                                <Button variant="contained" color="primary" onClick={() => this.setState({ openQuotList : true })}>
                                    A partir d'un devis existant
                                </Button>
                            </Box>
                        }
                    </Box>
                    {openQuotList &&
                        <InputSelectMagasin
                            label="Devis"
                            value={this.state.selectQuot}
                            options={previousQuot.map( action =>
                                ({value: action.quotation, label:`Devis du ${new Date(action.timeAction).toLocaleString()}`})
                            )}
                            onChange={this.handleChangePrevDevis}
                        />
                    }
                    <Forms
                        inStock={this.state.inStock} 
                        inStockList={this.state.inStockList} 
                        listName="products"
                        state={this.state} 
                        PRODUCTS={PRODUCTS} 
                        handleSelectProducts={this.handleSelectProducts} 
                        handleAddProd={this.handleAddProd}
                        handleDeleteProd={this.handleDeleteProd}
                        handleChange={this.handleChange} 
                    />

                    <Forms
                        inStock={this.state.inStock}
                        inStockList={this.state.inStockList}
                        listName="accessories"
                        state={this.state} 
                        PRODUCTS={PRODUCTS} 
                        handleSelectProducts={this.handleSelectProducts} 
                        handleAddProd={this.handleAddProd}
                        handleDeleteProd={this.handleDeleteProd}
                        handleChange={this.handleChange}
                    />
                    <Forms
                        inStock={this.state.inStock}
                        inStockList={this.state.inStockList}
                        listName="transport"
                        state={this.state} 
                        handleSelectProducts={this.handleSelectProducts} 
                        handleAddProd={this.handleAddProd}
                        handleDeleteProd={this.handleDeleteProd}
                        handleChange={this.handleChange}
                    />
                    <Forms
                        inStock={this.state.inStock}
                        inStockList={this.state.inStockList}
                        listName="mod"
                        state={this.state} 
                        handleSelectProducts={this.handleSelectProducts} 
                        handleAddProd={this.handleAddProd}
                        handleDeleteProd={this.handleDeleteProd}
                        handleChange={this.handleChange}
                    />
                    <Forms
                        inStock={this.state.inStock}
                        inStockList={this.state.inStockList}
                        listName="warranty"
                        state={this.state} 
                        handleSelectProducts={this.handleSelectProducts} 
                        handleAddProd={this.handleAddProd}
                        handleDeleteProd={this.handleDeleteProd}
                        handleChange={this.handleChange}
                    />                                                    
                            
                    <Box p={2} >
                        <Table className="table table-striped table-bordered">
                            <TableBody>
                                <TableRow style={{ backgroundColor: deepPurple[400] }}>
                                    <TableCell style={{minWidth:'300px', color: "white", fontWeight: 800 }} colSpan={3}>TOTAL HT</TableCell>
                                    <TableCell colSpan={2} style={{ color: "white", fontWeight: 800 }}>
                                        <Currency 
                                            value={
                                                this.state.newDevis.prodTotal + 
                                                this.state.newDevis.accTotal + 
                                                this.state.newDevis.transTotal + 
                                                this.state.newDevis.modTotal +
                                                this.state.newDevis.warrTotal
                                            }   
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                    {/* <hr/> */}

                    {/* <div className="p-5 m-5 text-center border">
                        <label className="fg-label">Commentaire *</label>
                        <div className={"form-group m-10 " + (this.state.errors.comments ? 'has-error' : "")}>
                            <div className='fg-line'>
                                <textarea
                                >
                                </textarea>
                                </div>
                                <small className="help-block">{this.state.errors.comments}</small>     
                                </div>
                            </div> */}
                    <Box p={1} >
                        <Card className="text-center">
                            <InputText
                                label="Commentaires"
                                name="comments"
                                value={this.state.newDevis.comments}
                                onChange={this.handleChange}
                                className="form-control"
                                rows="5"
                                error={this.state.errors.comments}
                            />
                        </Card>
                    </Box>
                    <Box p={1} >
                        <Card className="text-center">
                            <Box p={2}>
                                <h5>
                                    <span>Joindre Fichier(s)</span> 
                                </h5>
                                <Photos photoList={this.setFiles} photos={this.state.files === null ? [] : this.state.files } file />
                            </Box>
                        </Card>
                    </Box>

                    {/* <Box p={2}>
                        <div className="pull-right">
                            <a href="#"> // To scroll back to top after click VALIDATE 
                                <Button variant="contained" color="secondary" onClick={this.handleNext}>Valider</Button>
                            </a>
                            <Button onClick={this.props.handleClose}>Annuler</Button>
                        </div>
                    </Box> */}
                </Box>
                )}        
            </PopUp>

        )
    }
}


function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        PRODUCTS: state.inventory.products,
        // SHOPS: state.inventory.shops,
        STOCKS: state.inventory.stocks.AVAILABLE,
        CLIENTS: state.inventory.clients,
        loading: state.inventory.state.loading,
        state: state.inventory.requestState.devis,
        stateClient: state.inventory.requestState.clients,
        ACTIONS: state.prospects.ACTIONS,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({

        createAction,
        createClient,
        fetchAll,
        getClientInfoList,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NewDevisForm)